import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { autoFormatEnergyValue } from "@solarschools/component-lib/src/utilities/EnergyUnits";

const ResultItem = ({
  resourceType,
  resourceId,
  resourceName,
  slug,
  country,
  state,
  weatherIcon,
  temperature,
  capacity,
  siteCount,
}) => {
  const Icon = (weather) => {
    const icons = {
      "clear-day": "day",
      "clear-night": "night",
      rain: "rainy-3",
      snow: "snowy-4",
      sleet: "snowy-6",
      wind: "windy",
      fog: "cloudy-day-3",
      cloudy: "cloudy",
      "partly-cloudy-day": "cloudy-day-3",
      "partly-cloudy-night": "cloudy-night-3",
      hail: "thunder",
      thunderstorm: "thunder",
      tornado: "thunder",
    };
    return icons[weather];
  };

  const mapImage = (country, state, forceAU) => {
    let img = country || "world";
    if (forceAU) {
      img = "AU";
    } else if (country === "Australia") {
      if (state && abbreviateAuState(state)) {
        img = `AU-${abbreviateAuState(state)}`;
      } else {
        img = "AU";
      }
    }
    if (country === "United Kingdom") {
      img = `GB`;
    }
    return `/img/maps/${img}.svg`;
  };

  const abbreviateAuState = (state) => {
    const translations = {
      queensland: "QLD",
      "new south wales": "NSW",
      victoria: "VIC",
      "south australia": "SA",
      tasmania: "TAS",
      "northern territory": "NT",
      "australian capital territory": "ACT",
      "western australia": "WA",
    };
    return translations[state.toLowerCase()]
      ? translations[state.toLowerCase()]
      : false;
  };

  return (
    <li>
      <a
        href={`/schools/${slug}`}
        className="list-group-item p-2 bg-light rounded-0 border-left-0 border-right-0 m-0 align-items-baseline text-secondary d-block"
      >
        <div className="row w-100 m-0">
          <div className="col-2 col-sm-1 col-md-2 col-lg-1 p-1">
            <img
              className="w-100"
              src={mapImage(country, state, resourceType === "organisations")}
            />
          </div>
          <div className="col-10 col-sm-6 col-md-10 col-lg-6 pr-md-0">
            <p className="ss-subtitle mb-0 pb-0 align-items-center">
              <strong>
                <strong>{resourceName}</strong>
              </strong>
            </p>
            <small className="d-inline">
              {resourceType === "sites" ? (
                <Fragment>
                  {state}
                  {state && country ? ", " : null}
                  {country}
                </Fragment>
              ) : (
                <Fragment>{siteCount} Sites</Fragment>
              )}
            </small>
          </div>
          <div className="col-6 col-sm-3 col-md-6 col-lg-3 p-0 pl-md-2 text-center text-lg-left align-item-baseline">
            {weatherIcon ? (
              <div className="media">
                {" "}
                <img
                  width={40}
                  className="mr-1 d-none d-sm-inline"
                  src={`/img/weather/static/${Icon(weatherIcon)}.svg`}
                />
                <div className="media-body">
                  {" "}
                  <p className="text-subject-english m-0">
                    <strong>{temperature} &deg;C</strong>
                  </p>
                  <p className="m-0">Current Temp.</p>
                </div>
              </div>
            ) : null}
          </div>
          <div className="col-6 col-sm-2 col-md-6 col-lg-2 p-0 pl-md-2 text-center text-lg-left align-items-baseline">
            {capacity ? (
              <Fragment>
                <p className="text-primary m-0">
                  <strong>{autoFormatEnergyValue(capacity)}</strong>
                </p>
                <p className="m-0">Generation Capacity</p>
              </Fragment>
            ) : null}
          </div>
        </div>
      </a>
    </li>
  );
};

ResultItem.propTypes = {
  resourceType: PropTypes.string.isRequired,
  resourceId: PropTypes.number.isRequired,
  resourceName: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  country: PropTypes.string,
  state: PropTypes.string,
  weatherIcon: PropTypes.string,
  temperature: PropTypes.number,
  capacity: PropTypes.number,
  siteCount: PropTypes.number,
};

export default ResultItem;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolSearch/ResultItem.js